// extracted by mini-css-extract-plugin
module.exports = {"card":"JobOfferEntry_card__PORpY","photoPart":"JobOfferEntry_photoPart__1i3D1","textPart":"JobOfferEntry_textPart__350we","rewardPart":"JobOfferEntry_rewardPart__2dfyS"};